import styled from 'styled-components';
import { Button, ButtonStyled } from '@ch/common/components/button';
import { ButtonProps } from '@ch/common/components/button/types';
import { InputGroupAddon } from '@ch/common/components/input-group';
import { spacingStyle } from '@ch/common/const/spacing';
import { font } from '../../../const/font';
import { FormFileProps, FormFileWrapProps } from './types';

export const FormFileClearStyled = styled(Button)<ButtonProps>`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  display: block;
  z-index: 1;
  height: 50px;
  width: 50px;
  min-height: 50px;
`;

export const FormFileStyled = styled('input')<FormFileProps>`
  height: 32px;
  min-height: 32px;
  max-height: 32px;
  line-height: 8px;
  border-radius: 0;
  width: 100%;
  font-size: ${font.size.sm}px;
  -webkit-user-modify: read-write-plaintext-only;

  &::-webkit-file-upload-button {
    width: 0;
    padding: 0;
    display: block;
    box-sizing: border-box;
    visibility: hidden;
  }
`;

export const FormFileFieldWrapStyled = styled('div')<FormFileWrapProps>`
  position: relative;
  ${props => spacingStyle(props)}
`;

export const FormFileButtonStyled = styled(InputGroupAddon)<ButtonProps>`
  ${ButtonStyled} {
    letter-spacing: 1.65px;
    font-size: 11px;
    line-height: 48px;
    min-height: 48px;
    max-height: 48px;
    height: 48px;
    padding: 0 15px;
    text-align: center;
    width: 100%;
    text-transform: uppercase;
    overflow: hidden;
    border-radius: 0;
  }
`;

export const FormFileNameWrapper = styled('p')`
  margin: 0;
  text-overflow: ellipsis;
  white-space: pre;
  width: 100%;
  overflow: hidden;
  font-size: ${font.size.sm}px;

  ${({ hideControls }) =>
    !hideControls &&
    `
    text-align: center;
    `}
`;
